import { FC, memo } from 'react'
import i18n from '../../../utilities/i18n'
import Link from '../Link'

interface INotFoundErrorComponent {
    user?: string
}

const NotFoundErrorComponent: FC<INotFoundErrorComponent> = ({ user }) => {
    return (
        <p>
            {i18n.t('error.description.userMessageIntro')} <b>{user}</b>{' '}
            {i18n.t('error.description.userMessage')}{' '}
            <Link
                href="https://app.myfreecams.com"
                title="Online Models"
                underline
                inline
                mfc
            >
                {i18n.t('error.description.onlineModels')}
            </Link>{' '}
            {i18n.t('error.description.pageOr')}{' '}
            <Link
                href={`https://app.myfreecams.com/search`}
                title="Search"
                underline
                inline
                mfc
            >
                {i18n.t('error.description.search')}
            </Link>{' '}
            {i18n.t('error.description.searchMessageEnd')}
        </p>
    )
}

export default memo(NotFoundErrorComponent)
